import { css } from '@emotion/react';

import COLORS from 'shared/styles/colors';

export default css({
  '&.trend-copy-link': {
    borderRadius: '3px',
    border: `1px solid ${COLORS.NEUTRAL300}`,
    width: '30px',
    height: '30px',
    alignItems: 'center',
  },
  '.trend-copy-link': {
    '&__btn:focus::after': {
      animation: 'none',
    },
    '&__btn': {
      marginLeft: '0.35rem',

      '& svg': {
        color: COLORS.NEUTRAL300,
      },
    },
  },
});
